
// -----------CUSTOM JS START-------------------------
(function() {

  $(document).ready(function() {
      // Tab click functionality
    $(document).on("click", ".cstlogo_popup_mn .logos__slide__link", function() {
      var tabID = $(this).attr("data-trk-id");
      
      // Remove 'active' class from all tabs
      $('.cstlogo_popup_mn ul.tabs li.tab').removeClass('active');
      
      // Add 'active' class to the matching tab and trigger a click
      $('.cstlogo_popup_mn ul.tabs li.tab').each(function() {
        var popTabID = $(this).find('a').attr('data-trk-id');
        if (tabID == popTabID) {
          $(this).trigger("click");
        }
      });
    });
    
    // Image click to add class to modal
    $(document).on("click", ".cstlogo_popup_mn .logos__img img", function() {
      console.log("Image clicked!"); // Debugging step to check if the click event is triggered
      $(".cstlogo_popup_mn .modal").addClass("scrollable-selector-modal");
      $('body').addClass("overflowhiden");
      
      // Debugging step to check if the modal class is added
      if ($(".cstlogo_popup_mn .modal").hasClass("scrollable-selector-modal")) {
        console.log("Modal class added!");
      } else {
        console.log("Failed to add modal class.");
      }
    });
  
    // Modal close button
    $(document).on("click", '.large.modal-close-button', function() {
      $('.cstlogo_popup_mn .modal').removeClass('scrollable-selector-modal');
      $('body').removeClass("overflowhiden");
    });
    
    
    // Load data for all tabs on page load
    $('.tabs-container li.tab').each(function() {
      var dataUrl = $(this).attr('dataget');  // Get the URL from the 'dataget' attribute
      var tabID = $(this).find('a').attr('data-trk-id'); // Get the tab ID
      
      // Fetch data for each tab
      loadTabData(dataUrl, tabID);
    });

    // Click functionality to show data related to clicked tab
    $('.tabs-container li.tab').click(function() {
      if (!$(this).hasClass('active')) {
        // Remove 'active' class from all tabs
        $('.tabs-container li.tab').removeClass('active');
        // Add 'active' class to the clicked tab
        $(this).addClass('active');

        var tabID = $(this).find('a').attr('data-trk-id');
        
        // Show only the related content and hide others
        $('.secondary-selector').hide();  // Hide all
        $('.secondary-selector[data-trk-id="' + tabID + '"]').show();  // Show the matching div
      }
    });

    // Initially, hide all content except for the first active tab's content
    $('.secondary-selector').hide(); // Hide all initially
    $('.tabs-container li.tab.active').each(function() {
      var initialTabID = $(this).find('a').attr('data-trk-id');
      $('.secondary-selector[data-trk-id="' + initialTabID + '"]').show(); // Show only the active tab's content
    });

    $('button.description_readM').click(function () {
      $('.hero__description.rte').toggleClass('more');
      if ($('.hero__description.rte').hasClass('more')){
        $('button.description_readM').text('Read less');
      }else{
        $('button.description_readM').text('Read more');
      }
    });
    
  });

  // Function to load tab data via AJAX and assign it to the relevant div
  function loadTabData(dataUrl, tabID) {
    if (dataUrl) {
      $.ajax({
        url: dataUrl,
        method: 'GET',
        success: function(response) {
          var tempDiv = $('<div>').html(response);
          var gridItems = tempDiv.find('.grid-item.collection-item');
          
          // Check if there are any items to show
          if (gridItems.length === 0) {
            $('.secondary-selector[data-trk-id="' + tabID + '"]').html('<p>No items found.</p>');
            return;
          }
          
          // Clear existing items in the secondary selector div
          var targetDiv = $('.secondary-selector[data-trk-id="' + tabID + '"]');
          targetDiv.empty();
          
          // Loop through and append new items
          gridItems.each(function() {
            var imgSrc = $(this).find('img').attr('src');
            var itemName = $(this).find('span').text();
            var itemLink = $(this).find('a').attr('href');
            
            var newItem = `
              <div class="secondary-selector-item">
                <a href="${itemLink}" class="secondary-selector-btn">
                  <img loading="lazy" src="${imgSrc}" alt="${itemName}" class="scrollable-selector-img">
                  <div class="secondary-item-name">${itemName}</div>
                </a>
              </div>`;
            
            // Append each new item to the target div
            targetDiv.append(newItem);
          });
        },
        error: function() {
          $('.secondary-selector[data-trk-id="' + tabID + '"]').html('<p>Failed to load data.</p>');
        }
      });
    }
  }

})();

document.addEventListener("DOMContentLoaded", function() {
  const reviewParent = document.querySelector('.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge');
  const reviews = document.querySelectorAll('.jdgm-prev-badge__stars');

  if (reviews) {
    reviews.forEach(function(review) {
      const rating = parseInt(review.getAttribute('data-score')); 

      if (rating < 4) {
        reviewParent.style.setProperty('display', 'none', 'important');
      } else {
        reviewParent.style.setProperty('display', 'block', 'important');
      }
    });
  }
});







